import { FlexBetween } from ".";
import { ICategories } from "@/interfaces";
import { cn } from "@/lib";
import { BdAltArrowDown } from "solar-icon-react/bd";
import { cva } from "class-variance-authority";
import Link from "next/link";

const boxStyles = cva(
  "xl:py-4 py-2 xl:px-5 px-2 sm:gap-2 cursor-pointer md:flex-row flex-col rounded-xl bg-white shadow-main border-2 border-b-0",
  {
    variants: {
      variant: {
        "emerald-mint": " border-emerald-mint",
        "sky-bliss": "border-sky-bliss",
        "teal-ocean": " border-teal-ocean",
        "sunset-gold": " border-sunset-gold",
        "yellow-500": " border-yellow-500",
        "rose-500": " border-rose-500",
      },
    },
  },
);

const iconStyles = cva(
  "lg:size-10 xl:size-12 size-6 lg:p-2 p-1 flex-center rounded-full overflow-hidden",
  {
    variants: {
      variant: {
        "emerald-mint": "bg-emerald-mint",
        "sky-bliss": "bg-sky-bliss",
        "teal-ocean": "bg-teal-ocean",
        "sunset-gold": "bg-sunset-gold",
        "yellow-500": "bg-yellow-500",
        "rose-500": "bg-rose-500",
      },
    },
  },
);

const textStyles = cva("", {
  variants: {
    variant: {
      "emerald-mint": "text-emerald-mint!",
      "sky-bliss": "text-sky-bliss!",
      "teal-ocean": "text-teal-ocean!",
      "sunset-gold": "text-sunset-gold!",
      "yellow-500": "text-yellow-500!",
      "rose-500": "text-rose-500!",
    },
  },
});

const SelectableServiceBox = ({
  icon,
  category,
  href,
  onClick,
  id,
  variant,
}: ICategories & { onClick: (id: string) => void }) => {
  const [firstLabelPart, secondLabelPart] = category.split(" ");
  const handleClick = () => {
    onClick(id);

    // Scroll to the target section if href is provided
    if (href) {
      const targetId = href.split("#")[1];
      if (targetId) {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
    }
  };
  return (
    <Link href={href} title={`${firstLabelPart} ${secondLabelPart}`}>
      <FlexBetween onClick={handleClick} className={boxStyles({ variant })}>
        <FlexBetween gap={2} className="flex-col md:flex-row">
          <span className={iconStyles({ variant })}>{icon}</span>
          <FlexBetween
            gap={1}
            className="text-micro font-bold md:text-xs lg:text-lg"
          >
            <span>{firstLabelPart}</span>
            <span className={textStyles({ variant })}>{secondLabelPart}</span>
          </FlexBetween>
        </FlexBetween>
        <BdAltArrowDown
          className={cn(
            "size-4! md:rotate-90! lg:size-6!",
            textStyles({ variant }),
          )}
        />
      </FlexBetween>
    </Link>
  );
};

export default SelectableServiceBox;
